<h2 mat-dialog-title>Configure Team Leader Coverage</h2>

<mat-dialog-content>
  <p class="dialog-copy">
    Distribute games across Team Leaders per league. Coverage per league must
    total 100%.
  </p>

  <p class="config-meta" *ngIf="config">
    Last updated {{ config.updatedAt | date : 'medium' }}
  </p>

  <div class="loading-message" *ngIf="loading">Loading coverage...</div>

  <div class="coverage-table-wrap" *ngIf="!loading">
    <div class="coverage-table-scroll">
      <table class="coverage-table">
        <thead>
          <tr>
            <th>League</th>
            <th>Team Leader</th>
            <th>Coverage %</th>
            <th aria-label="Actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let index = index">
            <td>
              <select
                class="coverage-control"
                [ngModel]="row.leagueShortName"
                (ngModelChange)="onLeagueChanged(row, $event)"
                [ngModelOptions]="{ standalone: true }"
                aria-label="League"
              >
                <option value="">Select league</option>
                <option
                  *ngFor="let league of data.leagueOptions"
                  [value]="league"
                >
                  {{ league }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="coverage-control"
                [(ngModel)]="row.teamLeaderAuthId"
                [ngModelOptions]="{ standalone: true }"
                aria-label="Team Leader"
              >
                <option value="">Select Team Leader</option>
                <option
                  *ngFor="let teamLeader of data.teamLeaders"
                  [value]="teamLeader.auth0Id"
                >
                  {{ teamLeader.name }}
                </option>
              </select>
            </td>
            <td>
              <input
                class="coverage-control coverage-input"
                type="number"
                min="0"
                max="100"
                step="1"
                [(ngModel)]="row.coverage"
                [ngModelOptions]="{ standalone: true }"
                aria-label="Coverage percentage"
              />
            </td>
            <td>
              <button
                mat-icon-button
                class="delete-row"
                type="button"
                aria-label="Remove coverage row"
                (click)="removeRow(index)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <button mat-button type="button" class="add-row" (click)="addRow()">
      <mat-icon>add</mat-icon>
      Add row
    </button>
  </div>

  <div class="coverage-badges" *ngIf="coverageSums.length > 0">
    <span
      class="coverage-badge"
      *ngFor="let item of coverageSums"
      [class.valid]="item.coverage === 100"
      [class.invalid]="item.coverage !== 100"
    >
      <mat-icon>{{
        item.coverage === 100 ? 'check_circle' : 'warning'
      }}</mat-icon>
      {{ item.leagueShortName }}: {{ item.coverage }}%
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    class="save-continue"
    type="button"
    [disabled]="loading || saving || !allValid"
    (click)="saveAndContinue()"
  >
    Save &amp; Continue
  </button>
</mat-dialog-actions>
